import {Component, OnInit} from '@angular/core';
import {MercadoriasCategoriasService} from "./mercadorias-categorias.service";
import {MercadoriasCategoriasModel} from "./mercadorias-categorias.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {TranslateService} from '@ngx-translate/core';
import {LoginService} from "../login/login.service";

declare let swal: any;

@Component({
  selector: 'app-mercadorias-categorias',
  templateUrl: './mercadorias-categorias.component.html'
})
export class MercadoriasCategoriasComponent extends Components implements OnInit {

  categorias: MercadoriasCategoriasModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private mercadoriasCategoriasService: MercadoriasCategoriasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'mercadorias'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.mercadoriasCategoriasService.getPaginacao(1,this.itensPorPagina, ["mercadoria"])
      .subscribe(data => {
        this.categorias = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.categorias);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  delete(categoria) {
    let categorias = this.categorias;
    let mercadoriasCategoriasService = this.mercadoriasCategoriasService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarCategoria')+categoria.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(categorias);
        }

        let index = categorias.indexOf(categoria);
        categorias.splice(index, 1);

        mercadoriasCategoriasService.apagar(categoria.id_categoria)
          .subscribe(res => {
              self.categorias = categorias;
            },
            err => {
              // Revert the view back to its original state
              categorias.splice(index, 0, categoria);
              self.categorias = categorias;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.mercadoriasCategoriasService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.categorias = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/mercadorias-categorias/mercadorias-categorias.component.ts